module.exports = __webpack_public_path__ + "static/media/termopary5ru.b3bb33ff.pdf";